// Hook for geolocation
import { useState, useCallback } from "react";
import { useTranslation } from "react-i18next";

export interface UseLocationReturn {
  userLocation: string;
  setUserLocation: React.Dispatch<React.SetStateAction<string>>;
  locationError: string;
  setLocationError: React.Dispatch<React.SetStateAction<string>>;
  isGettingLocation: boolean;
  getLocation: () => Promise<void>;
}

export const useLocation = (): UseLocationReturn => {
  const { t } = useTranslation();
  
  const [userLocation, setUserLocation] = useState<string>("");
  const [locationError, setLocationError] = useState<string>("");
  const [isGettingLocation, setIsGettingLocation] = useState(false);

  const getLocation = useCallback(async () => {
    setIsGettingLocation(true);
    setLocationError("");

    try {
      const position = await new Promise<GeolocationPosition>(
        (resolve, reject) => {
          navigator.geolocation.getCurrentPosition(resolve, reject, {
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 300000,
          });
        }
      );

      const { latitude, longitude } = position.coords;
      const googleMapsUrl = `https://maps.google.com/?q=${latitude},${longitude}`;
      setUserLocation(googleMapsUrl);
    } catch (error) {
      setLocationError(t("menu.cart.location.error"));
    } finally {
      setIsGettingLocation(false);
    }
  }, [t]);

  return {
    userLocation,
    setUserLocation,
    locationError,
    setLocationError,
    isGettingLocation,
    getLocation,
  };
};
